export default {
  "verify.filmSearchId": "作品番号",
  "verify.clientCode": "取引先番号",
  "verify.ticketAmount": "着券金額",
};